import React from 'react';
import _get from 'lodash/get';
import useStableClientDetails from 'components/Hooks/useStableClientDetails';
import InternalSupportWidget from 'components/InternalSupportWidget';

const useInternalSupportWidget = ({ containerClassName }) => {
  const { clientDetails } = useStableClientDetails();
  const clientMetadata = _get(clientDetails, 'metadata');
  const showInternalSupportWidget = _get(clientMetadata, 'showInternalSupport');

  const renderInternalSupportWidget = () => {
    if (!showInternalSupportWidget) return null;

    return <InternalSupportWidget containerClassName={containerClassName} />;
  };

  return { showInternalSupportWidget, renderInternalSupportWidget };
};

export default useInternalSupportWidget;
